import { Component, Input, OnInit } from '@angular/core';
import { JobRoleUtilsService } from '../../services/job-role-utils.service';

@Component({
    selector: 'app-job-role-display',
    templateUrl: './job-role-display.component.html',
    styleUrls: ['./job-role-display.component.scss']
})
export class JobRoleDisplayComponent implements OnInit {

    @Input() roleName: string = '';
    @Input() showTooltip: boolean = true;
    @Input() cssClass: string = '';

    displayName: string = '';
    needsTooltip: boolean = false;
    fullName: string = '';

    constructor(private jobRoleUtils: JobRoleUtilsService) { }

    ngOnInit(): void {
        this.updateDisplay();
    }

    ngOnChanges(): void {
        this.updateDisplay();
    }

    private updateDisplay(): void {
        this.displayName = this.jobRoleUtils.truncateJobRoleName(this.roleName);
        this.needsTooltip = this.jobRoleUtils.needsTruncation(this.roleName);
        this.fullName = this.jobRoleUtils.getFullJobRoleName(this.roleName);
    }
} 